export const EXPORT_PIPELINE_ANALYTICS = gql`
  mutation ExportPipelineAnalytics($input: ExportPipelineAnalyticsInput!) {
    exportPipelineAnalytics(input: $input) {
      success
      eventId
    }
  }
`
